// previewFlag.js
// needed as resolveVariables() hook can happen before react is mounted, so context hasn't run yet
// make sure every page calls setPreview() once before any resolvers are run, which call resolveVariables() and need this singleton
let preview = false;
export const setPreview = v => (preview = !!v);
export const isPreview = () => preview;
